"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallType = void 0;
var CallType;
(function (CallType) {
    CallType["INBOUND"] = "inboundPhoneCall";
    CallType["OUTBOUND"] = "outboundPhoneCall";
})(CallType || (exports.CallType = CallType = {}));
